import {
  Language,
  TranslationKey,
  translations,
} from '../translations/translations';

export function t(lang: Language, key: TranslationKey): string {
  return translations[lang]?.[key] || translations['en'][key] || key;
}
